import { render, staticRenderFns } from "./OxyIndicatorLights.vue?vue&type=template&id=4b44b940&"
import script from "./OxyIndicatorLights.vue?vue&type=script&lang=ts&"
export * from "./OxyIndicatorLights.vue?vue&type=script&lang=ts&"
import style0 from "./OxyIndicatorLights.vue?vue&type=style&index=0&id=4b44b940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports